import { Button, Stack, Typography } from '@mui/material';
import SelectMerchant from './SelectMerchant';
import SelectCatalog from './SelectCatalog';
import { useState } from 'react';
import CatalogProductsTable from './CatalogProductsTable';
import { CatalogProductsClient } from 'src/app/api/clients/catalogProducts';
import { useNavigate, useParams } from 'react-router-dom';

const AddProductFromCatalog = () => {
  const navigate = useNavigate();
  const [selectedMerchantId, setSelectedMerchantId] = useState(null);
  const [selectedCatalogId, setSelectedCatalogId] = useState(null);
  const { merchantId, catalogId } = useParams();

  const handleAddProducts = () => {
    if (!selectedMerchantId || !selectedCatalogId || !merchantId || !catalogId)
      return alert('Select a merchant and a catalog.');
    CatalogProductsClient.copyMerchantCatalog(merchantId, catalogId, {
      merchant_id: selectedMerchantId,
      catalog_id: selectedCatalogId,
    }).then(() => navigate('../..', { relative: 'path' }));
  };

  return (
    <>
      <Typography variant="h5">
        Select a Merchant and one of its Catalogs.
      </Typography>
      <Stack direction="row" spacing={2} my={4}>
        <SelectMerchant
          selectedMerchantId={selectedMerchantId}
          setSelectedMerchantId={setSelectedMerchantId}
        />
        {selectedMerchantId && (
          <SelectCatalog
            selectedMerchantId={selectedMerchantId}
            selectedCatalogId={selectedCatalogId}
            setSelectedCatalogId={setSelectedCatalogId}
          />
        )}
      </Stack>
      {selectedMerchantId && selectedCatalogId && (
        <CatalogProductsTable
          merchantId={selectedMerchantId}
          catalogId={selectedCatalogId}
        />
      )}
      <Stack mt={2}>
        <Button
          onClick={handleAddProducts}
          variant="flat"
          sx={{ alignSelf: 'flex-end' }}
        >
          Add Products
        </Button>
      </Stack>
    </>
  );
};

export default AddProductFromCatalog;
